'use client'

// MUI Imports
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Skeleton from '@mui/material/Skeleton'
import Divider from '@mui/material/Divider'

// Types
interface LoadingStateProps {
  glassmorphismStyle: Record<string, any>
}

const LoadingState = ({ glassmorphismStyle }: LoadingStateProps) => {
  return (
    <Card elevation={0} sx={{ ...glassmorphismStyle }}>
      <CardContent sx={{ p: 2 }}>
        <Stack direction='row' alignItems='center' spacing={2.5} sx={{ pr: 5 }}>
          {/* Bloco 1: Localização */}
          <Stack alignItems='center' spacing={1}>
            <Skeleton variant='text' width={100} height={24} />
            <Skeleton variant='text' width={80} height={16} />
          </Stack>

          {/* Bloco 2: Ícone e temperaturas */}
          <Stack alignItems='center' spacing={1}>
            <Skeleton variant='rounded' width={48} height={48} />
            <Stack direction='row' alignItems='center' spacing={1}>
              <Skeleton variant='text' width={30} height={16} />
              <Skeleton variant='text' width={30} height={16} />
            </Stack>
          </Stack>

          {/* Bloco 3: Temperatura atual */}
          <Stack alignItems='center' spacing={1}>
            <Skeleton variant='text' width={80} height={40} />
            <Skeleton variant='text' width={100} height={16} />
          </Stack>

          {/* Bloco 4: Próximas 3 horas */}
          <Stack spacing={0.8} sx={{ minWidth: 180 }}>
            <Skeleton variant='text' width={80} height={10} sx={{ alignSelf: 'center' }} />
            <Stack direction='row' spacing={1.5} sx={{ justifyContent: 'center' }}>
              {[1, 2, 3, 4, 5].map((index) => (
                <Stack key={index} alignItems='center' spacing={0.3} sx={{ minWidth: 50 }}>
                  <Skeleton variant='text' width={30} height={8} />
                  <Skeleton variant='rounded' width={20} height={20} />
                  <Skeleton variant='text' width={25} height={10} />
                </Stack>
              ))}
            </Stack>
          </Stack>

          {/* Bloco 5: Detalhes do clima - 2 colunas */}
          <Stack direction='row' spacing={2}>
            <Stack spacing={0.4}>
              <Skeleton variant='text' width={110} height={14} />
              <Skeleton variant='text' width={100} height={14} />
              <Skeleton variant='text' width={90} height={14} />
              <Skeleton variant='text' width={105} height={14} />
            </Stack>

            <Stack spacing={0.4}>
              <Skeleton variant='text' width={95} height={14} />
              <Skeleton variant='text' width={105} height={14} />
              <Skeleton variant='text' width={115} height={14} />
              <Skeleton variant='text' width={85} height={14} />
            </Stack>
          </Stack>

          {/* Divider */}
          <Divider orientation="vertical" flexItem sx={{ mx: 3, opacity: 0.8 }} />

          {/* Previsão próximos dias */}
          <Stack direction='row' spacing={1.5}>
            {[1, 2].map((index) => (
              <Stack key={index} alignItems='center' spacing={0.4} sx={{ minWidth: 75 }}>
                <Skeleton variant='text' width={60} height={10} />
                <Skeleton variant='rounded' width={28} height={28} />
                <Skeleton variant='text' width={45} height={10} />
                <Skeleton variant='text' width={60} height={9} />
              </Stack>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default LoadingState
